import React, { useMemo } from 'react';
import { Box, costFormater, List } from '@common-fe/common-fe';

import { DEFAULT_CARD_EXP_DATE_FORMAT } from '@/common/constants';

import { useGetFundIcon } from '../../hooks';
import {
  InvestmentActivitySide,
  TransactionHistoryPayload,
  TransactionStatus,
} from '../../investments.types';
interface Props extends TransactionHistoryPayload {
  index: number;
  onClick: () => void;
}
const ActivityPreviewCard: React.FC<Props> = ({
  status,
  id,
  name,
  side,
  symbol,
  image,
  amount,
  date,
  index,
  onClick,
}) => {
  const handleGetFundIcon = useGetFundIcon();
  const formattedDate = useMemo(() => {
    return date.format(DEFAULT_CARD_EXP_DATE_FORMAT);
  }, [date]);
  const opacity = useMemo(() => {
    if (index === 3) {
      return 0.75;
    }
    if (index >= 4) {
      return 0.5;
    }
    return 1;
  }, [index]);
  const isBuyMode = useMemo(() => {
    return side === InvestmentActivitySide.BUY;
  }, [side]);
  const isCanceledMode = useMemo(() => {
    return status === TransactionStatus.Canceled;
  }, [status]);
  const formattedAmount = useMemo(() => {
    let currentAmount = amount < 0 ? amount * -1 : amount;
    if (!isBuyMode) {
      currentAmount = currentAmount * -1;
    }

    return costFormater(currentAmount, {
      isPrecision: true,
      prefix: isBuyMode ? '+$' : '$',
    });
  }, [amount, isBuyMode]);

  return (
    <List.Item
      testId={`activity-preview-card_${id}`}
      pad="s"
      key={id}
      height={{ min: '62px' }}
      round="container1Round"
      onClick={onClick}
      style={{ opacity: opacity, marginTop: index === 0 ? 0 : undefined }}
    >
      {handleGetFundIcon({
        image,
        // status: status,
        isGreyMode: isCanceledMode,

        isNullMode: true,
      })}
      <Box direction="column" fill margin={{ left: 'xs' }}>
        <List.Item.Text
          color={isCanceledMode ? 'textDisabled' : 'textBody'}
          data-testId={`activity-preview-card_${id}_name`}
          truncate
          weight={700}
        >
          {name}
        </List.Item.Text>
        <List.Item.Text
          color={isCanceledMode ? 'textDisabled' : 'textSecondary'}
          data-testId={`activity-preview-card_${id}_symbol`}
          size="small"
        >
          {symbol}
        </List.Item.Text>
      </Box>

      <div>
        <Box direction="column" margin={{ left: 'xl' }} align="end">
          <List.Item.Text
            data-testId={`activity-preview-card_${id}_value`}
            weight={700}
            color={isCanceledMode ? 'textDisabled' : isBuyMode ? 'success' : 'investmentsLoss'}
          >
            {formattedAmount}
          </List.Item.Text>
          <List.Item.Text
            data-testId={`activity-preview-card_${id}_date`}
            size="small"
            color={isCanceledMode ? 'textDisabled' : 'textSecondary'}
          >
            {formattedDate}
          </List.Item.Text>
        </Box>
      </div>
    </List.Item>
  );
};
export default ActivityPreviewCard;
